import React, { useState } from 'react';
import { useEffect } from 'react';
import { message } from 'antd';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/index';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { apiGetMineInfo, apiGetPage } from './request/api'
import LoginPage from './pages/login'
import Header from './components/header'
import DefaultHeader from './components/defaultHeader'
import About from './pages/about'
import Service from './pages/service'
import News from './pages/news'
import Home from './pages/home'
import ContactUs from './pages/contactus'
import Mine from './pages/mine'
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeWrapper from "./components/theme"
import './assets/css/index.css'
import "antd/dist/reset.css"
import './assets/iconfont/iconfont.css'

type ProtectedRouteProps = {
    element: React.ComponentType<any>;
    [key: string]: any;
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);


    return null;
};
const ConditionalHeader = () => {
    const location = useLocation(); // [!code ++]
    const shouldShowHeader = !['/login'].includes(location.pathname);
    return shouldShowHeader ? <Header /> : <DefaultHeader />;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element: Component, ...rest }) => {
    const token = localStorage.getItem('userToken');
    // 如果没有 token，重定向到 /login
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // 如果有 token，渲染目标组件
    return <Component {...rest} />;
};

const useTokenValidation = () => {
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null); // null 表示初始状态，未验证

    useEffect(() => {
        const token = localStorage.getItem('userToken');
        if (!token) {
            setIsLoggedIn(false);
            return;
        }


        const validateToken = async () => {
            try {
                const res = await apiGetMineInfo();
                if (res.data.data !== null) {
                    setIsLoggedIn(true);
                } else {
                    setIsLoggedIn(false);
                    message.error(languageCode === 'zh' ? '登录已过期，请重新登录' : 'Login expired, please log in again');
                    localStorage.setItem('userToken', '');
                }
            } catch (err) {
                console.error('Error fetching user info:', err);
                setIsLoggedIn(false);
                message.error(languageCode === 'zh' ? '登录已过期，请重新登录' : 'Login expired, please log in again');
                localStorage.setItem('userToken', '');
            }
        };

        validateToken();

        let intervalId: NodeJS.Timeout | null = null;
        if (isLoggedIn === null) {
            validateToken().then(() => {
                if (isLoggedIn) {
                    intervalId = setInterval(validateToken, 60000);
                }
            });
        } else if (isLoggedIn) {
            intervalId = setInterval(validateToken, 60000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [isLoggedIn])

    return isLoggedIn;
};

const AppWrapper = () => {
    useTokenValidation(); // 使用自定义 Hook，仅用于触发定时验证逻辑
    return (
        <Routes>
            <Route path="/index" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/service" element={<Service />} />
            <Route path="/news" element={<News />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/mine" element={<ProtectedRoute element={Mine} />} />
            <Route path="*" element={<Navigate to="/index" replace />} />
        </Routes>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <ThemeWrapper>
            <Router>
                <ConditionalHeader />
                <ScrollToTop />
                <AppWrapper />
            </Router>
        </ThemeWrapper>
    </Provider>
);

reportWebVitals();